import { Button } from '../../components/ui';
import './Medico.css';

export default function AccionesEditarEliminar() {
  return (
    <div className="medico-actions">
      <Button variant="secondary" size="sm">Editar</Button>
      <Button variant="dangerSoft" size="sm">Eliminar</Button>
    </div>
  );
}